import React from 'react';
import AddIcon from '@mui/icons-material//Add';
import { Button } from '@mui/material';
import { CreateNewVersionButtonProps } from './types';

const CreateNewVersionButton = (params: CreateNewVersionButtonProps) => {
  const { onClickHandler } = params;
  return (
    <Button color="primary" endIcon={<AddIcon />} onClick={onClickHandler} variant="outlined">
      Create new valuation version
    </Button>
  );
};

export default CreateNewVersionButton;
